import React, { Fragment } from 'react';
import { Home } from 'react-feather';
import { Link } from 'react-router-dom';
import Bookmark from './Bookmark';
import BackButton from './buttons/BackButton';

const Breadcrumb = ({
  parent, title, actions, path, allowBack,
}) => (
  <>
    <div className="container-fluid">
      <div className="page-header">
        <div className="row">
          <div className="col">
            <div className="page-header-left">
              {allowBack && <BackButton />}
              <h3>{title}</h3>
              <ol className="breadcrumb pull-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <Home />
                  </Link>
                </li>
                <li className="breadcrumb-item">{parent}</li>
                {path && path.map((item) => <li className="breadcrumb-item">{item}</li>)}
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            </div>
          </div>
          {/* <!-- Bookmark Start--> */}
          {actions}
          {/* <!-- Bookmark Ends--> */}
        </div>
      </div>
    </div>
  </>
);

export default Breadcrumb;
